import React, { Component } from 'react';

const PLACE_HOLDER = 'notifica-potenziale-isee';

class NotificaPotenzialiIsee extends Component {
  componentDidMount() {
    setTimeout(() => window.PotenzialiPratiche && window.PotenzialiPratiche.avviaNotificaPotenzialiIsee(this.props, document.getElementById(PLACE_HOLDER)), 1000);
  }

  componentWillReceiveProps(props) {
    if (props.anno && props.ufficio && (this.props.anno !== props.anno || this.props.ufficio !== props.ufficio)) {
      window.PotenzialiPratiche && window.PotenzialiPratiche.avviaNotificaPotenzialiIsee(props, document.getElementById(PLACE_HOLDER));
    }
  }

  render() {
    return <span id={PLACE_HOLDER} />;
  }
}

export default NotificaPotenzialiIsee;
